import React, { useState, useEffect } from 'react';
import './Product.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import productImage1 from '../assets/fertilizer.jpg';
import productImage2 from '../assets/fertilizer1.jpg';
import productImage3 from '../assets/fertilizer3.jpg';
import productImage4 from '../assets/fertlizer2.jpg';
import productImage from '../assets/fertlizer4.jpg';
import productImage6 from '../assets/fertilizer6.jpg';
import productImage7 from '../assets/fertlizer7.jpg';
import productImage8 from '../assets/fertilizer8.jpg';
import productImage9 from '../assets/fertilizer9.jpg';
import productImage11 from '../assets/fertilizer11.jpg';
import productImage12 from '../assets/fertilizer12.jpg';

import adv from '../assets/adv1.jpg';
import adv2 from '../assets/adv2.jpg';
import adv3 from '../assets/adv3.jpg';
import adv4 from '../assets/adv4.jpg';
import adv6 from '../assets/adv6.jpg';
import farmVideo3 from '../assets/video3.mp4';

import proimg1 from '../assets/proimg1.png';
import proimg2 from '../assets/proimg2.png';
import proimg3 from '../assets/proimg3.png';
import proimg4 from '../assets/proimg4.png';
import proimg5 from '../assets/proimg5.png';
import proimg6 from '../assets/proimg6.png';
import proimg7 from '../assets/proimg7.png';


import person7 from '../assets/person7.jpg';
import person2 from '../assets/person2.jpg';
import person4 from '../assets/person4.jpg';
import person1 from '../assets/person1.jpg';
import person5 from '../assets/person5.jpg';
import person6 from '../assets/person6.jpg';

const products = [
  { name: 'Greehexa Growth', image: productImage1 },
  { name: 'Greehexa Boost', image: productImage6 },
  { name: 'Greehexa CZB', image: productImage8 },
  { name: 'Greehexa CHIORO 26', image: productImage },
  { name: 'FERO-P', image: productImage11 },
  { name: 'ZENKO-P', image: productImage12 },
];

const advertisements = [
  { image: productImage2, alt: 'Advertisement 1' },
  { image: productImage3, alt: 'Advertisement 2' },
  { image: productImage4, alt: 'Advertisement 3' },
  { image: productImage7, alt: 'Advertisement 4' },
  { image: productImage9, alt: 'Advertisement 5' },
  { image: adv, alt: 'Advertisement 6' },
  { image: adv2, alt: 'Advertisement 7' },
  { image: adv3, alt: 'Advertisement 8' },
  { image: adv4, alt: 'Advertisement 9' },
  { image: adv6, alt: 'Advertisement 10' },
];
const galleryImages = [
  person1,
  person2,
  person5,
  person4, 
  person6,
  person7,
];


const catalogueImages = [proimg1, proimg2, proimg3, proimg4, proimg5, proimg6, proimg7];

const productVideo = {
  title: 'Products Demonstration',
  url: farmVideo3,
  description: 'Watch this demonstration of our premium fertilizer products and learn how they can improve your crop yield.'
};

const Products = () => {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const waMessage = `Name: ${formData.name}\nEmail: ${formData.email}\nMessage: ${formData.message}`;
    const phoneNumber = '7350552704';
    const waURL = `https://wa.me/91${phoneNumber}?text=${encodeURIComponent(waMessage)}`;
    window.open(waURL, '_blank');
    closeModal();
  };

  return (
    <div className="products-container">
      <h1>Our Fertilizer Products</h1>
      <p className="products-subtitle">High-quality fertilizers for better yield and sustainable farming.</p>

      <div className="products-grid">
        {products.map((product, index) => (
          <div className="product-card" key={index} data-aos="fade-up">
            <span className="product-badge">Best Seller</span>
            <img src={product.image} alt={product.name} className="product-image" />
            <div className="product-info">
              <h3>{product.name}</h3>
              <button className="get-price-button" onClick={openModal}>Get Price</button>
            </div>
          </div>
        ))}
      </div>

      {/* Video Section */}
      <div className="product-video-section" data-aos="fade-up">
        <h2>PRODUCT DEMONSTRATION</h2>
        <p className="video-subtitle">
          Watch our product demonstration to learn more about our fertilizers
        </p>
        <div className="single-video-container" data-aos="fade-up">
          <div className="video-player">
            <video controls>
              <source src={farmVideo3} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="video-info">
            <h3>{productVideo.title}</h3>
            <p>{productVideo.description}</p>
          </div>
        </div>
      </div>

      {/* Catalogue Section */}
      <div className="catalogue-section" data-aos="fade-up">
        <h2>Product Catalogue</h2>
        <p className="catalogue-subtitle">Explore our wide range of agricultural solutions.</p>
        <div className="catalogue-grid">
          {catalogueImages.map((img, idx) => (
            <div className="catalogue-card" key={idx}>
              <img src={img} alt={`Catalogue ${idx + 1}`} className="catalogue-image" />
            </div>
          ))}
        </div>
      </div>

      {/* Advertisement Section */}
      <div className="advertisement-section">
        <h2>ALSO SEE</h2>
        <div className="advertisement-grid">
          {advertisements.map((ad, index) => (
            <div key={index} className="advertisement-card" data-aos="fade-up">
              <img src={ad.image} alt={ad.alt} className="advertisement-image" />
              <div className="advertisement-overlay"></div>
            </div>
          ))}
        </div>
      </div>
{/* Image Gallery Section 
<div className="image-gallery-section" data-aos="fade-up">
  <h2>Image Gallery</h2>
  <p className="gallery-subtitle">Check out more photos from our products and events.</p>
  <div className="gallery-grid">
    {galleryImages.map((img, idx) => (
      <div className="gallery-card" key={idx}>
        <img src={img} alt={`Gallery ${idx + 1}`} className="gallery-image" />
      </div>
    ))}
  </div>
</div>
*/}
      {/* Modal Form */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Contact Us</h2>
            <form onSubmit={handleFormSubmit} className="get-price-form">
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input type="text" id="name" value={formData.name} onChange={handleFormChange} required />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input type="email" id="email" value={formData.email} onChange={handleFormChange} required />
              </div>
              <div className="form-group">
                <label htmlFor="message">Your Message</label>
                <textarea id="message" value={formData.message} onChange={handleFormChange} rows="4" required></textarea>
              </div>
              <button type="submit" className="submit-button">Send Message</button>
            </form>
            <button className="close-modal-button" onClick={closeModal}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Products;
